import { render, staticRenderFns } from "./Audits.vue?vue&type=template&id=24caa4cc&"
import script from "./Audits.vue?vue&type=script&lang=ts&"
export * from "./Audits.vue?vue&type=script&lang=ts&"
import style0 from "./Audits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports